export default {"src":"/portal/_next/static/media/handshake.39bc28c5.svg","height":69,"width":70,"blurWidth":0,"blurHeight":0};